/* ======================================================================
   Cooking Instructions Navigation Menu Item
   Injects a dropdown menu item into the header navigation (desktop + mobile)
   ====================================================================== */
(function addCookingInstructionsNav() {
  document.addEventListener('DOMContentLoaded', () => {
    // Function to add menu item to a specific navigation
    function addToNav(navSelector, navType) {
      const nav = document.querySelector(navSelector);

      if (!nav) return false;

      // Check if already added to this nav
      const existingId = `menu-item-cooking-instructions-${navType}`;
      if (document.getElementById(existingId)) return true;

      // Find the "Contact" menu item
      const menuItems = Array.from(nav.children);
      const contactIndex = menuItems.findIndex(li => {
        const link = li.querySelector('a');
        return link && link.textContent.trim().toLowerCase().includes('contact');
      });

      if (contactIndex === -1) return false; // Contact not found

      // Create cooking instructions menu item
      const cookingMenuItem = document.createElement('li');
      cookingMenuItem.id = existingId;
      cookingMenuItem.className = 'has-submenu';
      cookingMenuItem.setAttribute('aria-controls', `SiteNavLabel-cooking-instructions-${navType}`);
      cookingMenuItem.setAttribute('aria-expanded', 'false');

      // Add submenu-back button for mobile/sidebar navigation
      const submenuBack = navType === 'sidebar' ? `
        <li class="submenu-back">
          <a><span class="icon">
            <svg width="13" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.414.086 7.9 6.57 6.485 7.985 0 1.5 1.414.086Z" fill="#000"/><path d="M12.985 1.515 6.5 8 5.085 6.586 11.571.101l1.414 1.414Z" fill="#000"/></svg>
          </span>Back</a>
        </li>
      ` : '';

      cookingMenuItem.innerHTML = `
        <a title="Cooking Instructions" class="menu-link" href="#">
          <span><span class="text-animation--underline-in-header">Cooking Instructions</span></span>
          <span class="icon">
            <svg width="13" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.414.086 7.9 6.57 6.485 7.985 0 1.5 1.414.086Z" fill="#000"/><path d="M12.985 1.515 6.5 8 5.085 6.586 11.571.101l1.414 1.414Z" fill="#000"/></svg>
          </span>
        </a>

        <ul class="submenu normal-menu" id="SiteNavLabel-cooking-instructions-${navType}">
          <div class="submenu-holder">
            ${submenuBack}
            <li>
              <a title="Sunny Toor Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/st" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Sunny Toor Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Mung Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/mm" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Mung Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Trinity Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/tm" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Trinity Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Meadow Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/meadow" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Meadow Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Yogi Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/ym" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Yogi Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Sundown Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/sd" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Sundown Mix</span></span>
              </a>
            </li>
            <li>
              <a title="Vida Mix" class="menu-link no-focus-link" href="https://thelentilhub.com/pages/vm" target="_blank" rel="noopener">
                <span><span class="text-animation--underline-in-header">Vida Mix</span></span>
              </a>
            </li>
          </div>
        </ul>
      `;

      // Insert before Contact menu item
      nav.insertBefore(cookingMenuItem, menuItems[contactIndex]);

      // Initialize dropdown functionality (matching section-header.js behavior)
      const rtl = document.documentElement.getAttribute('dir') === 'rtl';
      const submenu = cookingMenuItem.querySelector('.normal-menu');
      const menuLink = cookingMenuItem.querySelector('.menu-link');

      // Mouseover positioning for desktop (from section-header.js lines 178-184)
      if (navType === 'classic') {
        cookingMenuItem.addEventListener('mouseover', function() {
          if (submenu) {
            submenu.style.left = (rtl ? cookingMenuItem.getBoundingClientRect().right : cookingMenuItem.getBoundingClientRect().left) + 'px';
          }
        });
      }

      // Mobile/Sidebar navigation click handler
      if (navType === 'sidebar') {
        const mobileNav = cookingMenuItem.closest('mobile-navigation');

        menuLink.addEventListener('click', function(e) {
          e.preventDefault();

          // Access the mobile navigation element's internal state
          if (!mobileNav._openedFirstSubmenu) {
            mobileNav._openedFirstSubmenu = true;
            mobileNav.classList.add('opened-first-submenu');
            const sidebarDrawer = mobileNav.closest('sidebar-drawer');
            if (sidebarDrawer) {
              sidebarDrawer.scrollTo({top: 0});
            }
          }

          cookingMenuItem.classList.add('opened');

          // Resize container
          if (mobileNav._openedSecondSubmenu) {
            mobileNav.style.height = `${mobileNav.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
          } else if (mobileNav._openedFirstSubmenu) {
            mobileNav.style.height = `${mobileNav.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
          }
        });

        // Handle back button click
        const backButton = cookingMenuItem.querySelector('.submenu-back a');
        if (backButton) {
          backButton.addEventListener('click', function(e) {
            e.preventDefault();

            if (mobileNav._openedSecondSubmenu) {
              mobileNav._openedSecondSubmenu = false;
              mobileNav.classList.remove('opened-second-submenu');
            } else if (mobileNav._openedFirstSubmenu) {
              mobileNav._openedFirstSubmenu = false;
              mobileNav.classList.remove('opened-first-submenu');
              mobileNav.style.height = 'auto';
            }

            const sidebarDrawer = mobileNav.closest('sidebar-drawer');
            if (sidebarDrawer) {
              sidebarDrawer.scrollTo({top: 0});
            }

            setTimeout(() => {
              cookingMenuItem.classList.remove('opened');
            }, 301);
          });
        }
      }

      // Touch navigation for desktop (from section-header.js lines 234-245)
      if (navType === 'classic') {
        cookingMenuItem.addEventListener('touchstart', function() {
          menuLink.style.pointerEvents = 'none';
          cookingMenuItem.classList.toggle('focus');

          // Close other open submenus
          document.querySelectorAll('.style--classic li.focus').forEach(function(elm) {
            if (elm !== cookingMenuItem) {
              elm.classList.remove('focus');
            }
          });
        });
      }

      // Keyboard navigation (from section-header.js lines 249-278)
      cookingMenuItem.addEventListener('keydown', function(e) {
        var KEYCODES = { RETURN: 13, ESC: 27, TAB: 9 };

        if (e.keyCode === KEYCODES.RETURN) {
          if (!e.target.classList.contains('no-focus-link')) {
            e.preventDefault();
          }
          if (!cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.add('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'true');
          } else if (document.activeElement.parentNode.classList.contains('has-submenu') && cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.remove('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Focus out on last item to close dropdown
      var lastLink = cookingMenuItem.querySelector('.submenu-holder > li:last-child a');
      if (lastLink) {
        lastLink.addEventListener('focusout', function() {
          if (cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.remove('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'false');
          }
        });
      }

      return true;
    }

    // Try to add to both desktop and mobile navigation
    const checkNav = setInterval(() => {
      const classicAdded = addToNav('.site-nav.style--classic nav ul.link-list', 'classic');
      const sidebarAdded = addToNav('.site-nav.style--sidebar nav ul.link-list', 'sidebar');

      // Stop checking when both are added
      if (classicAdded && sidebarAdded) {
        clearInterval(checkNav);
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkNav), 10000);
  });
})();
